import { Grid } from '@mui/material';
import React, { useState } from 'react';
import SearchFilter from './CSP/SearchFilter';
import CspTable from './CSP/CspTable';
import BackdropLoader from '../General/Loader';
import SnackBar from '../General/SnackBar';
import { useEffect } from 'react';
import { GetCspList } from 'API/UserList/CspList';

const Index = () => {
  const [filter, setFilter] = useState({
    value: '',
    category: '',
    status: ''
  });
  const [Data, setData] = useState(null);
  const [IsLoading, setIsLoading] = useState(false);
  const [AlertMessage, setAlertMessage] = useState(null);
  const [AlertType, setAlertType] = useState('success');
  const [AlertOpen, setAlertOpen] = useState(false);
  const [Page, setPage] = useState(0);

  const handleFilterChange = (name, value) => {
    if (name === 'category') {
      setFilter({ ...filter, [name]: value });
    } else {
      if (/^[a-zA-Z0-9 ]*$/.test(value) || value === '') {
        setFilter({ ...filter, [name]: value });
      }
    }
  };

  const handleStatusFilterChange = (status) => {
    setFilter({ ...filter, status: status === 'select' ? '' : status });
    GetCspList({ ...filter, status: status === 'select' ? '' : status }, 1, setIsLoading, setData, handleAlertOpen);
    setPage(0);
  };

  const handleFilterClear = () => {
    const temp = filter.status;
    setFilter({ value: '', category: '', status: temp });
    GetCspList({ value: '', category: '', status: temp }, 1, setIsLoading, setData, handleAlertOpen);
    setPage(0);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage.page);
    GetCspList(filter, newPage.page + 1, setIsLoading, setData, handleAlertOpen);
  };

  const handleAlertOpen = (message, type) => {
    setAlertMessage(message);
    setAlertType(type);
    setAlertOpen(true);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  useEffect(() => {
    GetCspList(filter, Page + 1, setIsLoading, setData, handleAlertOpen);
  }, []);

  const handleSearch = () => {
    GetCspList(filter, Page + 1, setIsLoading, setData, handleAlertOpen);
  };

  return (
    <Grid>
      <BackdropLoader open={IsLoading} />
      <SnackBar open={AlertOpen} message={AlertMessage} type={AlertType} handleClose={handleAlertClose} />

      <Grid item xs={12}>
        <SearchFilter filter={filter} handleChange={handleFilterChange} handleFilterClear={handleFilterClear} handleSearch={handleSearch} />
        <CspTable
          handlePageChange={handlePageChange}
          page={Page}
          data={Data}
          filter={filter}
          handleGet={handleSearch}
          handleFilterClear={handleFilterClear}
          handleStatusFilterChange={handleStatusFilterChange}
        />
      </Grid>
    </Grid>
  );
};

export default Index;
